export const BAND_COLORS = {
  "160m": "#0d47a1",
  "80m": "#0288d1",
  "40m": "#64b5f6",
  "20m": "#fdd835",
  "15m": "#ff9800",
  "10m": "#e64a19",
}
